import UserService from "../../api/userService";
import {setApplicationError} from "../app/Slice";
import {createAsyncThunk} from "@reduxjs/toolkit";
import {SliceNames} from "../constants";

export const getLeaderboard =
    createAsyncThunk(`${SliceNames.LEADERBOARD}/getLeaderboard`,
        async (_, thunkAPI) => {
            try {
                const res = await UserService.fetchLeaderboard()
                return res.data
            } catch (e: any) {
                thunkAPI.dispatch(
                    setApplicationError({
                        isError: true,
                        statusCode: undefined
                    }))
                return thunkAPI.rejectWithValue(e)
            }
        })
